// src/hooks/api/useAuditLog.js
import { useQuery } from '@tanstack/react-query';
import { serverRequest } from '../../util/server_request';
import { notifyUser } from '../../util/util';

// Query Keys
export const auditLogKeys = {
  all: ['auditLog'],
  lists: () => [...auditLogKeys.all, 'list'],
  list: (pageNum, pageSize) => [...auditLogKeys.lists(), { pageNum, pageSize }],
};

// Fetch audit logs with pagination
export const useAuditLogs = (pageNum = 0, pageSize = 10) => {
  return useQuery({
    queryKey: auditLogKeys.list(pageNum, pageSize),
    queryFn: async () => {
      const result = await serverRequest('GET', `audit-logs?pageNum=${pageNum}&pageSize=${pageSize}`);
      return {
        content: result?.data?.content || [],
        totalElements: result?.data?.totalElements || 0,
      };
    },
    keepPreviousData: true,
    onError: (error) => {
      notifyUser('error', error.message || 'Failed to fetch audit logs', 'Data fetching failed');
    },
  });
};
